<template>
  <div class="space-y-4">
    <InvoiceInformation v-for="invoice in invoices" :key="invoice.id" :invoice="invoice" @updated="$emit('updated')" />
  </div>
</template>

<script>
import InvoiceInformation from "@/components/claim/details/invoice/InvoiceInformation.vue";

export default {
  props: {
    invoices: {
      type: Array,
      default: () => [],
    },
  },

  emits: ["updated"],

  components: {
    InvoiceInformation,
  },
};
</script>
